<script>
 export default {
   name: 'checkbox-rd',
   props: {
     name: {
       type: String,
       required: true
     },
     value: {
       default: false,
     },
     isDark: {
      type: Boolean,
      default: false,
     }
   },
   computed: {
     isChecked: {
       get() {
         return this.value;
       },
       set(value) {
         this.$emit("input", value);
       },
     },
   },
 }
</script>

<template>
  <div>
    <label :for="name" class="flex flex--center checkbox-rd" :class="{'checkbox-rd--active': isChecked, 'is-dark': isDark }">
      <input class="checkbox-org" :id="name" type="checkbox" :value="value" v-model="isChecked" />
      <icon-rd name="check" color="light" v-if="isChecked" />
    </label>
  </div>
</template>

<style lang="less" scoped>
  @import "../../less/redesign/base.less";
  .checkbox-rd {
    border: 1px solid @grey-input;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    &--active {
      background-color: @primary-blue;
      border-color: @primary-blue;
      &.is-dark {
        background-color: @grey-input;
        border-color: @grey-input;
      }
    }
  }
  .checkbox-org {
    width: 0;
    height: 0;
    outline: 0;
    border: none;
    visibility: hidden;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/ui/checkbox/Checkbox.vue